/**
 * Editor do modo «formato lista» no painel Empresas.
 * @param {{
 *   json: string,
 *   onJsonChange: (s: string) => void,
 *   disabled?: boolean,
 * }} props
 */
export function StoreCatalogListForm({ json, onJsonChange, disabled = false }) {
  let body = { showSections: true, showPhotos: true };
  try {
    const o = JSON.parse(json.trim() === '' ? '{}' : json);
    if (o && typeof o === 'object' && !Array.isArray(o)) {
      body = {
        showSections: o.showSections !== false,
        showPhotos: o.showPhotos !== false,
      };
    }
  } catch {
    /* mantém defaults */
  }

  function patch(key, value) {
    onJsonChange(JSON.stringify({ ...body, [key]: value }, null, 2));
  }

  return (
    <div className="space-y-3 rounded-xl border border-sky-700/20 bg-sky-500/[0.06] p-4 dark:border-sky-400/20 dark:bg-sky-500/[0.08]">
      <p className="text-xs font-semibold uppercase tracking-wide text-sky-900 dark:text-sky-200">
        Opções do formato lista
      </p>
      <label className="flex cursor-pointer items-start gap-3 text-sm text-ink dark:text-mist">
        <input
          type="checkbox"
          checked={body.showSections}
          disabled={disabled}
          onChange={(e) => patch('showSections', e.target.checked)}
          className="mt-0.5 h-4 w-4 rounded border-ink/30 text-sky-600 focus:ring-sky-500 dark:border-white/25"
        />
        <span>
          <span className="font-semibold">Agrupar por secções</span>
          <span className="mt-0.5 block text-xs font-normal text-ink/65 dark:text-mist/65">
            Mostra cabeçalhos de categoria entre as linhas. O menu lateral de categorias não aparece neste formato.
          </span>
        </span>
      </label>
      <label className="flex cursor-pointer items-start gap-3 text-sm text-ink dark:text-mist">
        <input
          type="checkbox"
          checked={body.showPhotos}
          disabled={disabled}
          onChange={(e) => patch('showPhotos', e.target.checked)}
          className="mt-0.5 h-4 w-4 rounded border-ink/30 text-sky-600 focus:ring-sky-500 dark:border-white/25"
        />
        <span>
          <span className="font-semibold">Miniaturas de foto</span>
          <span className="mt-0.5 block text-xs font-normal text-ink/65 dark:text-mist/65">
            Foto pequena à esquerda; ao clicar abre o modal de imagens do produto.
          </span>
        </span>
      </label>
    </div>
  );
}
